import { render, staticRenderFns } from "./SimpleDetail.vue?vue&type=template&id=e5fbfae8&scoped=true&"
import script from "./SimpleDetail.vue?vue&type=script&lang=js&"
export * from "./SimpleDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5fbfae8",
  null
  
)

export default component.exports